"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _SelectMixin = require("../../mixins/components/SelectMixin");
var _FormControl = require("../FormControl/FormControl");
/**
 * A basic [HTML select element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select)
 * where you provide your on `option` children. You can also generate options from a data set using
 * the `DataSelect` component.
 *
 * @related ['DataSelect', 'FormField', 'ReadOnlySelect']
 * @since 2.1.0
 */
var Select = /*#__PURE__*/(0, _styledComponents.default)(_FormControl.FormControl).withConfig({
  displayName: "Select",
  componentId: "c11n-8-107-0__sc-1p9r1r3-0"
})(["", ""], _SelectMixin.SelectMixin);
exports.Select = Select;
Select.displayName = 'Select';
Select.propTypes = {
  /**
   * `<option>` and `<optgroup>` nodes
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Displays the select in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * Displays the select in an error state. Can also be inherited from a FormField parent.
   */
  error: _propTypes.default.bool,
  /**
   * Selects are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the select's width is set to `auto`.
   */
  fluid: _propTypes.default.bool,
  /**
   * Determines the size of the select.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.INPUT_SIZES)),
  /**
   * Indicates the select is required. Can also be inherited from a FormField parent.
   */
  required: _propTypes.default.bool,
  /**
   * styled-components forwarded `as` component.
   * @ignore
   */
  forwardedAs: _propTypes.default.string
};
Select.defaultProps = {
  fluid: true,
  size: _constants.INPUT_SIZES.md,
  forwardedAs: 'select'
};

/** @component */